/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, FUNCTIONS){
	const a = 'is-active';

	const slider = () => {
		$('.idx-main-slider').slick({
			autoplay: true,
			autoplaySpeed: 6000,
			slidesToShow: 1,
			slidesToScroll: 1,
			loop: true,
			arrows: false,
			dots: true,
			speed: 500,
			appendDots: $('.idx-main-content-in-dotted'),
			responsive: [{
				breakpoint: 768
			}],
		});

		if ($('.idx-main-notices-slide').length) {
			$('.idx-main-notices-slide').slick({
				autoplay: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				loop: true,
				arrows: false,
				dots: false,
				speed: 300
			});
		}

		// 初期表示
		slideTextAdd();
		$('.idx-main-bnr').addClass(a);

		// スライダー切り替わり時
		$('.idx-main-slider').on('afterChange', (slick, currentSlide) => {
			slideTextAdd();
		});

		let addHtml, addMore, thisLabel, thisTitle, thisLink, thisLead, thisLeadSlice;
		function slideTextAdd() {
			$('.idx-main-content-add').remove();
			thisLabel = $('.idx-main-slider .slick-active .idx-main-slider-item-label').text();
			thisTitle = $('.idx-main-slider .slick-active .idx-main-slider-item-title').text();
			thisLink = $('.idx-main-slider .slick-active .idx-main-slider-item-a').attr('href');

			// lead部分
			// thisLead = $('.idx-main-slider .slick-active .idx-main-slider-item-lead').text();
			// thisLeadSlice;
			// let winW = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
			// if(winW > 1300) {
			// 	thisLeadSlice = thisLead.length > 100 ? (thisLead).slice(0,100)+"…" : thisLead;
			// 	console.log('pc');
			// }else if(winW > 1024) {
			// 	thisLeadSlice = thisLead.length > 22 ? (thisLead).slice(0,22)+"…" : thisLead;
			// 	console.log('pc');
			// } else if(winW > 768){
			// 	thisLeadSlice = thisLead.length > 100 ? (thisLead).slice(0,100)+"…" : thisLead;
			// 	console.log('tab');
			// } else {
			// 	thisLeadSlice = thisLead.length > 100 ? (thisLead).slice(0,100)+"…" : thisLead;
			// 	console.log('sp');
			// }
			addHtml = '<div class="idx-main-content-add">'+
				'<a href="'+thisLink+'" class="idx-main-content-in-a">'+
				'<p class="idx-main-content-in-label">'+thisLabel+'</p>'+
				'<h2 class="idx-main-content-in-title mt10">'+thisTitle+'</h2></a><div class="mod-button01 mt40"><a href="'+thisLink+'" target="_blank">VIEW MORE</a></div></div>';

			$('.idx-main-content-in').prepend(addHtml);
		}
	};

	slider();

})(window.jQuery, window.FUNCTIONS);
